export const ERROR_MESSAGES = Object.freeze({
  AI_ERROR_TEXT: 'An error occurred with the AI. Please try again.',
});

export const PLACEHOLDERS = Object.freeze({
  AI_ELEMENT_GENERATOR:
    'Write some directions for the next generated element. Specify characters,\n outcomes, and @mention components\n for tailored generation.',
  AI_ELEMENT_ENHANCER:
    'Write some directions for the enhanced element. Specify characters,\n outcomes, and @mention components\n for tailored enhancement.',
});
